import { useNavigate } from "react-router-dom";
import {
  DevFeedback,
  PageFallback,
  useAuth,
} from "@jana-technology/platform-ui";

import { LOGIN_ROUTE } from "constants/routing";
import { isProductionEnv } from "helpers/env-checks";

export const LoginError = () => {
  const { error } = useAuth();

  const navigate = useNavigate();

  /*
  DevFeedback tries to show the actual OAuthError object, or Error.
  Refer to OAuthError class in Platform UI, but the gist is that
  error.message will be either error.error_description or error.error
  if it is an OAuthError; otherwise, it's a play JavaScript error.
  */

  return (
    <PageFallback
      heading="Login Failed"
      paragraph={error?.error_description || "Please try again later."}
      primaryButtonText="Back to Login"
      onPrimaryClick={() => navigate(LOGIN_ROUTE)}
    >
      {!isProductionEnv() && error ? (
        <DevFeedback
          errorName={error.error || error.name}
          errorMessage={error.message}
        />
      ) : null}
    </PageFallback>
  );
};

export default LoginError;
